// extracted by mini-css-extract-plugin
export default {"error":"GenericError_error__ocG0e","title":"GenericError_title__xYspE","message":"GenericError_message__hugSr","code":"GenericError_code__WlReO"};